import { register } from "./registry";
import { toast } from "./toast";

register((root) => {
  const table = root.querySelector<HTMLTableElement>("table[data-kit-draft-list], [data-kit-draft-list] table");
  if (!table) return;

  const rows = table.querySelectorAll<HTMLTableRowElement>("tbody tr");
  rows.forEach((row) => {
    row.addEventListener("keydown", async (e) => {
      if (e.altKey && (e.key === "p" || e.key === "P")) {
        e.preventDefault();
        // Kit list rows carry the draft only in their link (…/Entry?id=…).
        const id = row.getAttribute("data-id") ?? new URL(row.dataset.href ?? "", location.origin).searchParams.get("id");
        if (!id) return;
        try {
          const res = await fetch(`/api/v1/cash-bank-vouchers/${id}/post`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          });
          if (res.ok) {
            const body = await res.json();
            toast("ok", `Posted ${body.number}`);
            row.remove();
          } else {
            const err = await res.json().catch(() => ({ message: "Failed to post draft" }));
            toast("error", err.message || "Failed to post draft");
          }
        } catch {
          toast("error", "Network error posting draft");
        }
      }
    });
  });
});
